
import React, { ReactNode } from 'react';
import { AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';

interface AccordionSectionProps {
  value: string;
  icon: React.ReactNode;
  title: string;
  children: ReactNode;
}

const AccordionSection: React.FC<AccordionSectionProps> = ({ 
  value, 
  icon, 
  title, 
  children 
}) => {
  return (
    <AccordionItem value={value}>
      <AccordionTrigger className="flex items-center">
        <div className="flex items-center gap-2">
          {icon}
          <span>{title}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        {children}
      </AccordionContent>
    </AccordionItem>
  );
};

export default AccordionSection;
